import { HelmetDexteel } from "@dexteel/mesf-core";
import { RollsBlankManager } from "./components/RollsBlankManager";

export const RollsBlankPage = () => {
	return (
		<>
			<HelmetDexteel title="Rolls Blank" />
			<RollsBlankManager />
		</>
	);
};
